module.exports = __webpack_public_path__ + "components/forecast-table/static/freezing-level-afcfe8586460318ec43c89772e7e6a43.jpg";